// src/components/organism/CreateSix/stepConfig.ts
import { InfoIcon } from "shared-portal-component";

import type { CreateSixStep } from "@/types/six/Six";
import StepName from "@/components/organism/CreateSix/steps/StepName";
import StepDescription from "@/components/organism/CreateSix/steps/StepDescription";
import StepOwners from "@/components/organism/CreateSix/steps/StepOwner";
import StepInternalParticipants from "@/components/organism/CreateSix/steps/StepInternalParticipants";
import StepExternalParticipants from "@/components/organism/CreateSix/steps/StepExternalParticipants";
import StepInviteExternal from "@/components/organism/CreateSix/steps/StepInviteExternal";

export const STEP_CONFIG: Record<
  CreateSixStep,
  {
    component: React.FC<{ onClose: () => void }>;
    title: string;
    iconTooltip?: string;
    infoIcon?: React.ComponentType<{ className?: string }>;
  }
> = {
  Name: { component: StepName, title: "What do you want to name your new SIX?", iconTooltip: "Your SIX name must be unique.", infoIcon: InfoIcon },
  Description: { component: StepDescription, title: "Do you want to give your SIX a short description? \n You can also leave this field blank", iconTooltip: "You can leave this field blank.", infoIcon: InfoIcon },
  Owners: { component: StepOwners, title: "Who will own this new SIX?", iconTooltip: "Owners can manage this SIX.", infoIcon: InfoIcon },
  InternalParticipants: { component: StepInternalParticipants, title: "Invite others in your organization to this SIX?", iconTooltip: "Select internal users as participants.", infoIcon: InfoIcon },
  ExternalParticipants: { component: StepExternalParticipants, title: "Invite external users to this SIX?", iconTooltip: "Select external users as participants.", infoIcon: InfoIcon },
  NewExternalParticipant: { component: StepInviteExternal, title: "Invite a new external user", iconTooltip: "You can invite a new external user.", infoIcon: InfoIcon }
};

export const getStepConfig = (step: CreateSixStep) => STEP_CONFIG[step];
